var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgControlType(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.008 3.00019C15.2853 3.00019 15.52 3.09619 15.712 3.28819C15.904 3.48019 16 3.71485 16 3.99219V13.0002C16 13.2775 15.904 13.5122 15.712 13.7042C15.52 13.9069 15.2853 14.0082 15.008 14.0082H1.008C0.730667 14.0082 0.490667 13.9069 0.288 13.7042C0.096 13.5122 0 13.2775 0 13.0002V3.00019H15.008ZM1.008 13.0002H15.008V3.99219H1.008V13.0002ZM1.008 1.00019V1.99219H0V1.00019C0 0.722854 0.096 0.488187 0.288 0.296187C0.490667 0.0935208 0.730667 -0.0078125 1.008 -0.0078125H5.008C5.28533 -0.0078125 5.52 0.0935208 5.712 0.296187C5.904 0.488187 6 0.722854 6 1.00019V1.99219H5.008V1.00019H1.008Z",
    fill: "#474747"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgControlType);
export default __webpack_public_path__ + "static/media/control-type.891f90bfb5703e4140b379d9bde0a20c.svg";
export { ForwardRef as ReactComponent };